// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__cucF8","item":"Pagination_item__kHSYv"};